import OProjectNavTranslator from './o-project-nav-translator.vue'

export default OProjectNavTranslator
